import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHeaderContext } from '~/components/layout/Header/HeaderContext';
import MobileAccordionItem from '~/components/layout/Header/MobileNavigation/MobileAccordionItem';
import { headerButtons, headerMenu } from '~/components/layout/Header/data';
import { Link } from '~/components/ui/Link.tsx';
import { cn } from '~/helpers/utils';

const HeaderNavigation = () => {
  const { mobileOpen, closeMobile } = useHeaderContext();

  const linkClasses =
    'block rounded px-3 py-2 text-sm text-blue-800 no-underline transition-colors hover:bg-stone-50 hover:text-blue-600';

  return (
    <div
      id="mobile-nav"
      className={cn(
        'fixed inset-0 z-[999998] md:hidden',
        'transition-opacity duration-300',
        mobileOpen
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0'
      )}
      role="dialog"
      aria-modal="true"
      aria-label="Navigatiemenu"
    >
      <div
        className="absolute inset-0 bg-black/50"
        onClick={closeMobile}
        aria-hidden
      />

      <div
        className={cn(
          'absolute right-0 top-0 h-full w-80 max-w-[90vw] bg-white shadow-2xl',
          'flex flex-col overflow-hidden',
          'transition-transform duration-300 ease-in-out',
          mobileOpen ? 'translate-x-0' : 'translate-x-full'
        )}
      >
        <nav className="flex-1 overflow-y-auto pt-16">
          {headerMenu.map((item) => {
            if ('subMenuType' in item && item.subMenuType === 'mega') {
              return (
                <MobileAccordionItem
                  key={`mobile-nav-item-${item.label}`}
                  label={item.label}
                >
                  {item.subMenu.map(({ heading, links }) => (
                    <div key={heading} className="pb-4 last:pb-0">
                      <span className="mb-2 block px-2 uppercase text-black">
                        {heading}
                      </span>
                      <ul className="space-y-0.5">
                        {links.map((link) => (
                          <li key={link.href}>
                            <a
                              href={link.href}
                              className={linkClasses}
                              onClick={closeMobile}
                            >
                              {link.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </MobileAccordionItem>
              );
            }

            if ('subMenuType' in item && item.subMenuType === 'dropdown') {
              return (
                <MobileAccordionItem
                  key={`mobile-nav-item-${item.label}`}
                  label={item.label}
                >
                  <ul className="space-y-0.5">
                    {item.subMenu.map((link) => (
                      <li key={link.href}>
                        <a
                          href={link.href}
                          className={linkClasses}
                          onClick={closeMobile}
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </MobileAccordionItem>
              );
            }

            return (
              <div
                key={`mobile-nav-item-${item.label}`}
                className="border-t border-stone-100 px-4 py-1 first:border-t-0"
              >
                <a
                  href={item.href}
                  className="block py-3 font-display text-sm font-bold text-stone-700 no-underline transition-colors hover:text-blue-600"
                  onClick={closeMobile}
                >
                  {item.label}
                </a>
              </div>
            );
          })}

          {headerButtons.length > 0 && (
            <div className="px-4 pb-6 pt-4">
              {headerButtons.map((button) => (
                <Link
                  key={button.label}
                  variant={button.variant}
                  size="medium"
                  className="w-full justify-center"
                  onClick={closeMobile}
                  href={button.href}
                  rel={
                    button.target === '_blank'
                      ? 'external noopener noreferrer'
                      : ''
                  }
                  target={button.target}
                >
                  {button.label}
                  <FontAwesomeIcon icon={faAngleRight} />
                </Link>
              ))}
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};

export default HeaderNavigation;
